import dayJS from '@/lib/dayjs';

export function formatInsightSinceFromJobTime(
  time: number | string | undefined,
  isEnglish: boolean
): string | undefined {
  if (time === undefined || time === '') {
    return undefined;
  }
  const unix = Number(time);
  if (!Number.isFinite(unix) || unix <= 0) {
    return undefined;
  }
  const formatted = dayJS.unix(unix).format('YYYY/MM/DD');
  if (isEnglish) {
    return `Since ${formatted}`;
  }
  return `${formatted}-наас хойш`;
}
